import { render, staticRenderFns } from "./display-value-block.vue?vue&type=template&id=d65139cc&scoped=true&"
import script from "./display-value-block.vue?vue&type=script&lang=js&"
export * from "./display-value-block.vue?vue&type=script&lang=js&"
import style0 from "./display-value-block.vue?vue&type=style&index=0&id=d65139cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65139cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VCardTitle,VTooltip})
